import { Slider, TextField, Typography } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { useContext, useEffect, useState } from "react";
import { OverallDataContext } from "../../pages/CalculatorPage";
import FieldCounter from "./FieldCounter";

export default function LimitSumField({ counterId, options, units, category, onChangeHandler, setFocus, isReadOnly, sumLimit = 100, isInteger=false, dependentOn=null }) {
    const placeholderData = useContext(OverallDataContext).placeholderData;
    
    const [totalLimit, setTotalLimit] = useState();
    const isTwoOptions = options.length === 2;

    const [values, setValues] = useState(() =>
        Object.fromEntries(options.map((f) => [f?.id_name, 0]))
    );

    const handleChange = (opt_id_name, newValue) => {
        newValue = parseFloat(newValue) || 0;
        newValue = Math.max(0, Math.min(totalLimit, newValue));
        newValue = isInteger ? Math.round(newValue) : Math.round(newValue * 100) / 100;

        if (isTwoOptions) {
            const [first, second] = options.map(o => o.id_name);
            const updatedValues = {
                [first]: opt_id_name === first ? newValue : totalLimit - newValue,
                [second]: opt_id_name === first ? totalLimit - newValue : newValue
            };
            setValues(updatedValues);

            Object.entries(updatedValues).forEach(([name, val]) =>
                onChangeHandler({ name, value: val })
            );
        } else {
            let totalOther = Object.entries(values)
                .filter(([key]) => key !== opt_id_name)
                .reduce((sum, [, v]) => sum + v, 0);
            let adjusted = Math.max(0, Math.min(totalLimit - totalOther, newValue));
            adjusted = isInteger ? Math.round(adjusted) : Math.round(adjusted * 100) / 100;


            const updated = { ...values, [opt_id_name]: adjusted };
            setValues(updated);
            onChangeHandler({ name: opt_id_name, value: adjusted });
        }
    };

    useEffect(() => {
        // Placeholder population
        const newValues = Object.fromEntries(
            options.map((f) => [f?.id_name, parseFloat(placeholderData?.[category]?.[f?.id_name] || 0)])
        );
        setValues(newValues);

        if (typeof sumLimit === 'string') {
            const [ref_tab, ref_idname] = sumLimit.split(";");
            setTotalLimit(parseFloat(placeholderData?.[ref_tab]?.[ref_idname]) || 0);
        } else {
            setTotalLimit(sumLimit);
        }
    }, [placeholderData]);

    return (
        <>
            {options.map((opt, i) => {
                const opt_id_name = opt?.id_name;
                const isEditable = !isReadOnly && (!isTwoOptions || i === 0); // Only first is editable if 2 options
                return (
                    <Grid key={opt_id_name} container spacing={1} mb={1}>
                        <Grid xs={4} sm={3} className='vertically-centered' title={opt.caption}>
                            <Typography color="text.secondary">{opt.label}</Typography>
                        </Grid>
                        <Grid xs={0} sm={true} className='vertically-centered'>
                            <Slider
                                value={values[opt_id_name] || 0}
                                min={0}
                                max={totalLimit}
                                step={isInteger ? 1 : 0.01}
                                onChange={(e, v) => isEditable && handleChange(opt_id_name, v)}
                                onFocus={() => setFocus(true)}
                                onBlur={() => setFocus(false)}
                                disabled={!isEditable}
                                sx={{ display: { xs: 'none', sm: 'block' } }}
                            />
                        </Grid>
                        <Grid xs={true} sm={3}>
                            <TextField
                                size="small"
                                value={values[opt_id_name] || ''}
                                inputProps={{ min: 0, max: totalLimit, step: isInteger ? 1 : 0.01 }}
                                onChange={(e) => isEditable && handleChange(opt_id_name, e.target.value)}
                                onFocus={() => setFocus(true)}
                                onBlur={() => setFocus(false)}
                                readOnly={!isEditable}
                                disabled={!isEditable}
                                fullWidth
                            />
                        </Grid>
                        <Grid xs={units ? 'auto' : 0} className='vertically-centered'>
                            <Typography color="text.secondary">{units}</Typography>
                        </Grid>
                    </Grid>
                );
            })}

            <Grid container spacing={1}>
                <Grid xs={4} sm={3} />
                <Grid xs={true} className='centered-container' sx={{ borderTop: '2px solid lightgrey' }}>
                    {counterId ? (
                        <FieldCounter counterId={counterId} withText={false} overrideAlwaysShow={true} />
                    ) : (
                        <Typography color="text.secondary">Total: {totalLimit || "__"} {units}</Typography>
                    )}
                </Grid>
            </Grid>
        </>
    );
}
